<template>
  <v-container fluid py-0 px-0>
    <v-layout row class="interventionRowsTitle">
      <v-flex xs2 sm1 body-2>
        {{$t('interventions_title_type')}}
      </v-flex>
      <v-flex xs4 sm3 body-2>
        {{$t('interventions_title_name')}}
      </v-flex>
      <v-flex xs3 sm2 body-2>
        {{$t('interventions_title_category')}}
      </v-flex>
      <v-flex xs3 body-2 class="hidden-xs-only">
        {{$t('interventions_title_date')}}
      </v-flex>
      <v-flex xs3 sm3 pl-1 body-2 v-if="$vuetify.breakpoint.smAndUp">
        {{$t('interventions_title_status')}}
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <div :style="{ backgroundColor: noInteractionsColor}" class="no-data"
         v-if="interactionsList.length === 0 && !loading">
      <span :style="{color: getTextColor(noInteractionsColor)}">{{$t('interventions_no_data_found')}}</span>
    </div>
    <transition-group :name="interventionsListTransition" tag="div" class="minimum-height">
      <div v-for="interaction in filteredInteractionsList" :key="interaction.id" :class="tableRowClass" class="pt-1">

        <tutor-alert :alert="interaction.studentAlert" v-if="interaction.interactionType === 'ALERT'"
                     :id="interaction.id" :key="interaction.id" @row-clicked="alertClicked"></tutor-alert>

        <tutor-intervention v-if="interaction.interactionType === 'INTERVENTION'"
                            :id="interaction.id" :key="interaction.id" :intervention="interaction.intervention"
                            @row-clicked="interventionClicked" @delete-intervention="deleteIntervention"
                            @close-intervention="closeIntervention">
        </tutor-intervention>

        <student-exemption v-if="interaction.interactionType === 'EXEMPTION'" :exemption="interaction.exemption"
                           @row-clicked="exemptionClicked"/>
        <v-divider class="mt-1"></v-divider>
      </div>

    </transition-group>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import { DELETE_INTERVENTION_BY_ID, GET_INTERACTIONS_LIST } from '../../store/action-types'
  import { GET_ALL_VISIBLE_INTERVENTIONS, HAS_FEATURE_FLAG } from '../../store/getter-types'
  import {
    SET_CLOSE_INTERVENTION_FORM_INTERVENTION,
    SET_DRAWER_COMPONENT,
    SET_DRAWER_STATE,
    SET_INTERACTIONS_LIST_SCROLL_TOP,
    SET_DRAWER_COMPONENT_TITLE
  } from '../../store/mutation-types'
  import { components, componentTitles } from '../../store/modules/rightDrawer'
  import TutorIntervention from './TutorIntervention'
  import TutorAlert from './TutorAlert'
  import StudentExemptionRow from '../exemption/StudentExemptionRow'
  import StudentProfileInterventionHeader from './studentProfileIntervention/StudentProfileInterventionHeader'
  import StudentExemption from './TutorExemption'
  import Colors from '../../mixins/Colors'
  import Helpers from '../../mixins/Helpers'

  export default {
    name: 'tutor-interactions',
    mixins: [Colors, Helpers],
    data () {
      return {
        noInteractionsColor: this.$vuetify.theme.info
      }
    },
    computed: {
      ...mapState({
        loading: state => state.interactions.loading,
        scrollTop: state => state.interactions.scrollTop,
        interventionsListTransition: state => state.interactions.interactionsListTransition,
        moduleAlert: state => state.profile.module.alert,
        functionInteractions: state => state.interactions.functions.interactions,
        optionEnableAlertFilter: state => state.interactions.options.enable.alertFilter
      }),
      ...mapGetters({
        interactionsList: GET_ALL_VISIBLE_INTERVENTIONS,
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      filteredInteractionsList () {
        if (!this.flagEnableAlertFilter) {
          return this.interactionsList.filter(el => el.interactionType !== 'ALERT')
        }
        return this.interactionsList
      },
      flagEnableAlertFilter () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionInteractions + '.' + this.optionEnableAlertFilter)
      }
    },
    methods: {
      ...mapActions({
        getInteractions: GET_INTERACTIONS_LIST,
        deleteInterventionById: DELETE_INTERVENTION_BY_ID
      }),
      ...mapMutations({
        updateScrollTop: SET_INTERACTIONS_LIST_SCROLL_TOP,
        setDrawerComponent: SET_DRAWER_COMPONENT,
        setDrawerState: SET_DRAWER_STATE,
        setIntervention: SET_CLOSE_INTERVENTION_FORM_INTERVENTION,
        setDrawerComponentTitle: SET_DRAWER_COMPONENT_TITLE
      }),
      refreshTableOnScroll () {  // Used by FilteredTable
        this.getInteractions()
      },
      exemptionClicked (exemption) {
        const params = {id: exemption.student.id, exemption_id: exemption.id}
        this.$router.push({name: 'TutorExemption', params})
      },
      alertClicked (alert) {
        let params = {id: alert.student.id, alert_id: alert.id}
        this.$router.push({name: 'TutorAlert', params})
      },
      interventionClicked (intervention) {
        let params = {id: intervention.student.id, intervention_id: intervention.id}
        this.$router.push({name: 'TutorIntervention', params})
      },
      closeIntervention (intervention) {
        this.setDrawerComponent(components.CLOSE_INTERVENTION)
        this.setDrawerComponentTitle(componentTitles.CLOSE_INTERVENTION)
        this.setIntervention(intervention)
        this.setDrawerState(true)
      },
      deleteIntervention (intervention) {
        this.deleteInterventionById(intervention.id)
      }
    },
    watch: {
      interactionsList (value) {
        if (value.length === 0) {
          // Scroll to the top between filter changes to fix ST4-374
          window.scrollTo(0, 0)
        }
      }
    },
    created () {
      if (this.interactionsList.length === 0) {
        this.getInteractions()
      }
    },
    components: {
      StudentExemption,
      StudentProfileInterventionHeader,
      StudentExemptionRow,
      TutorIntervention,
      TutorAlert
    }
  }
</script>

<style scoped>
  .interventionRowsTitle {
    /*border-bottom: 1px solid gray;*/
  }

  .student-name {
    text-decoration: underline;
  }

  .minimum-height {
    min-height: 70vh;
  }

  /* The list transition is best for individual removal/addition */
  .list-enter-active {
    transition: all 1s;
  }

  .list-leave-active {
    transition: all 1.5s;
    position: absolute;
    width: 100%;
  }

  .list-enter {
    opacity: 1;
    transform: scale(0.4, 0.4) translateY(-100%) translateX(-150vw);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(0.4, 0.4) translateY(-100%) translateX(-150vw);
  }

  .list-move {
    transition: all 1s;
  }

  /* The all-list transition is best for updating the whole list*/
  .all-list-enter-active,
  .all-list-leave-active {
    transition: all 0.4s;
    opaque: 1;
  }

  .all-list-enter, .all-list-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translate(-16px, 0px)
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/TutorInteractions.vue